<div class="signature justify-content" [class.big]="useBigSignatureStickerMode">
  <div *ngIf="media" style="position: relative">
    <b
      class="sign"
      [style.background-color]="
        signatureTextBackground ? media.mediaClass.color : '#fff'
      "
      [style.color]="
        signatureTextBackground ? getTextColor(media.mediaClass) : '#000'
      "
      >{{ media.mediaClass.sign }}</b
    >
    <br />
    <span class="author">{{ Author }}</span>
    <br *ngIf="printSeries && hasSeries" />
    <span *ngIf="printSeries && hasSeries"> Bd. {{ series }} </span>
    <br />
    <div>
      <b class="id" *ngIf="printId">{{ media.id }}</b>
    </div>
    <div
      style="display: flex; justify-content: center"
      *ngIf="printAntolinIcon || signatureColorRectangle"
    >
      <img
        [src]="getIsbnUrl(media)"
        style="
          max-width: 30px;
          margin-left: 6px;
          margin-right: -12px;
          max-height: 18px;
          filter: drop-shadow(1px 1px 0 white) drop-shadow(-1px -1px 0 white)
            drop-shadow(1px -1px 0 white) drop-shadow(-1px 1px 0 white);
          object-fit: contain;
        "
        *ngIf="printAntolinIcon"
      />
      <span
        class="color-rectangle"
        *ngIf="signatureColorRectangle"
        [style.background-color]="media.mediaClass.color"
      ></span>
    </div>
  </div>
</div>
